



















import { Component, Vue, Mixins } from 'vue-property-decorator';
import VueHoduCommon from "@/mixin/VueHoduCommon";

import FeaturesCalendar        from '@/components/features/FeaturesCalendar.vue';
import FeaturesSchedule        from '@/components/features/FeaturesSchedule.vue';
import FeaturesTodo            from '@/components/features/FeaturesTodo.vue';
import FeaturesGroupAndTeam    from '@/components/features/FeaturesGroupAndTeam.vue';
import FeaturesCard            from '@/components/features/FeaturesCard.vue';
import FeaturesNotification    from '@/components/features/FeaturesNotification.vue';
import FeaturesFile            from '@/components/features/FeaturesFile.vue';
import FeaturesTalk            from '@/components/features/FeaturesTalk.vue';
import FeaturesTask            from '@/components/features/FeaturesTask.vue';
import FeaturesApproval            from '@/components/features/FeaturesApproval.vue';
import FeaturesAttend            from '@/components/features/FeaturesAttend.vue';
import FeaturesVideoConference from '@/components/features/FeaturesVideoConference.vue';

@Component({
   components: {
       FeaturesCalendar, FeaturesSchedule, FeaturesTodo, 
       FeaturesGroupAndTeam, FeaturesCard, FeaturesNotification, 
       FeaturesFile, FeaturesTalk, FeaturesTask, 
       FeaturesApproval, FeaturesAttend, FeaturesVideoConference, 
   }
}) export default class FeaturesSection extends Mixins(VueHoduCommon) {

    mounted() : void {

    }

}

